import * as React from "react";
import { Winder, alarmSeverityColors } from "../api/dataTypes";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import "../styles/Tables.css";
import matchSorter from 'match-sorter';

interface State {

}

export interface Props {
  systems: Winder[];
  loading: boolean;
  updateSystemSelection: (system: number) => void;
}

export class SystemSelectList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  getTrProps = (state: any, rowInfo: any, instance: any) => {
    if (rowInfo) {
      return {
        style: {
          background: alarmSeverityColors[rowInfo.original.alarmState],
        }
      }
    }
    return {};
  }

  render() {
    return (
      <div className="SysSelect component-standard">
        <ReactTable
          data={this.props.systems}
          filterable={true}
          defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}

          // COLUMNS ////////////////////////////////
          columns={[{
            Header: 'Select System',
            headerStyle: {
              fontWeight: "bold",
            },
            style: {
              textAlign: "left",
              padding: "1px",
            },
            // sortable: false,
            // filterable: false,
            Cell: row => (
              <div>
                <button className="iconButton"
                  onClick={() => {
                    this.props.updateSystemSelection(row.original.id);
                  }}
                >
                  {row.original.name}
                </button>

              </div>
            )
          }
          ]}
          // COLUMNS END //////////////////
          className="-highlight"
          showPagination={false}
          minRows={5}
          loading={this.props.loading}
          getTrProps={this.getTrProps}
        />
      </div>
    );
  }

}